import { UserManager, WebStorageStateStore } from "oidc-client-ts";

import * as oidcConfig from "../config/oidcConfig";

const oidcUserManager = new UserManager({
  authority: oidcConfig.authority,
  client_id: oidcConfig.clientId,
  redirect_uri: oidcConfig.redirectUri,
  post_logout_redirect_uri: oidcConfig.postLogoutRedirectUri,
  scope: oidcConfig.scope,
  response_type: "code",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true
});

const getUserManager = () => oidcUserManager;

export default getUserManager;
